import { Routes } from '@angular/router';
import {
  canMatchAuthGuard,
  canActivateAuthGuard,
  canActivateChildAuthGuard
} from './guards/auth/auth.guard';
import { Roles } from './models/security/roles';
import { Permission } from './models/security/permission.model';
import { redirectFromSpaPathGuard } from './guards/spa/redirect-from-spa-path.guard';
import { AuthGuardWithParams } from './services/auth-guards/auth-guard-with-params.ts.service';
import { turnResolve } from './products/kiosks/components/turns/turns.routes';


const supportFormUrl = 'https://www.tekus.co/soporte';

export const routes: Routes = [
  {
    path: 'spa',
    children: [
      {
        path: '**',
        canActivate: [redirectFromSpaPathGuard],
        children: []
      }
    ]
  },
  {
    path: 'Spa',
    children: [
      {
        path: '**',
        canActivate: [redirectFromSpaPathGuard],
        children: []
      }
    ]
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'qa/:id',
    loadComponent: () =>
      import('./components/page-qr-action/page-qr-action.component').then(
        (m) => m.PageQrActionComponent
      )
  },
  {
    path: 'transaction/:id',
    loadComponent: () =>
      import('./components/transaction/transaction.component').then(
        (c) => c.TransactionComponent
      )
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./components/shared/redirect/redirect.component').then(
        (c) => c.RedirectComponent
      ),
    data: {
      externalUrl: supportFormUrl,
      breadcrumb: 'support.Support'
    }
  },
  {
    path: 'soporte',
    loadComponent: () =>
      import('./components/shared/redirect/redirect.component').then(
        (c) => c.RedirectComponent
      ),
    data: {
      externalUrl: supportFormUrl,
      breadcrumb: 'support.Support'
    }
  },
  {
    path: 'express-support',
    loadComponent: () =>
      import('./components/shared/redirect/redirect.component').then(
        (c) => c.RedirectComponent
      ),
    data: {
      externalUrl: supportFormUrl,
      breadcrumb: 'support.Support'
    }
  },
  {
    path: 'soporte-expres',
    loadComponent: () =>
      import('./components/shared/redirect/redirect.component').then(
        (c) => c.RedirectComponent
      ),
    data: {
      externalUrl: supportFormUrl,
      breadcrumb: 'support.Support'
    }
  },
  {
    path: 'start',
    canMatch: [canMatchAuthGuard],
    canActivate: [canActivateAuthGuard],
    loadComponent: () =>
      import('./components/start/start/start.component').then(
        (m) => m.StartComponent
      ),
    data: {
      permissions: [
        new Permission('Messages', 'Index'),
        new Permission('Kiosks', 'Index'),
        new Permission('Devices', 'Index')
      ],
      roles: [Roles.Tenant, Roles.TenantLocation]
    }
  },
  {
    path: 'loader/:params',
    loadComponent: () =>
      import('src/app/components/shared/loader-media/loader-modal/loader-modal.component').then(
        (m) => m.LoaderModalComponent
      )
  },
  {
    path: 'screen-registration',
    canMatch: [canMatchAuthGuard],
    canActivate: [canActivateAuthGuard],
    loadComponent: () =>
      import(
        './products/screens/components/devices/screen-registration/screen-registration.component'
      ).then((m) => m.ScreenRegistrationComponent),
    data: {
      breadcrumb: 'device.RegisterScreen'
    }
  },
  {
    path: 'kiosks/turns/kitchen/:turnId',
    canMatch: [canMatchAuthGuard],
    canActivate: [canActivateAuthGuard],
    resolve: {
      turn: turnResolve
    },
    loadComponent: () =>
      import(
        './products/kiosks/components/turns/turn-kitchen-display/turn-kitchen-display.component'
      ).then((m) => m.TurnKitchenDisplayComponent),
    data: {
      permission: new Permission('Queues', 'Index'),
      feature: {
        Module: 'Kiosks',
        Feature: 'Queues'
      },
      roles: [Roles.Tenant, Roles.TenantLocation],
      breadcrumb: 'turns.KitchenDisplay'
    }
  },
  {
    path: 'account/resetPassword',
    loadComponent: () =>
      import(
        './components/account-management/reset-password/reset-password.component'
      ).then((m) => m.ResetPasswordComponent),
    data: {
      breadcrumb: {
        '': ''
      }
    }
  },
  {
    path: 'account/registration/:id',
    canActivate: [AuthGuardWithParams],
    loadComponent: () =>
      import(
        './components/account-management/registration/registration.component'
      ).then((m) => m.RegistrationComponent),
    data: {
      param: 'id',
      redirectTo: 'login',
      breadcrumb: 'registration.Registration'
    }
  },
  {
    path: 'account/email-verification',
    canActivate: [AuthGuardWithParams],
    loadComponent: () =>
      import(
        './components/account-management/email-verification/email-verification.component'
      ).then((m) => m.EmailVerificationComponent),
    data: {
      queryParam: 'userId,code',
      redirectTo: 'login',
      breadcrumb: 'emailVerification.EmailVerification'
    }
  },
  {
    path: '',
    canMatch: [canMatchAuthGuard],
    canActivate: [canActivateAuthGuard],
    loadComponent: () =>
      import('./components/layout/layout.component').then(
        (c) => c.LayoutComponent
      ),
    canActivateChild: [canActivateChildAuthGuard],
    children: [
      {
        path: 'messaging',
        loadChildren: () =>
          import('./products/messaging/components/messaging-routes').then(
            (m) => m.MESSAGING_ROUTES
          ),
        canMatch: [canMatchAuthGuard],
        data: {
          permission: new Permission('Messages', 'Index'),
          roles: [Roles.Tenant],
          breadcrumb: { skip: true }
        }
      },
      {
        path: 'screens',
        loadChildren: () =>
          import('./products/screens/components/screens-routes').then(
            (m) => m.SCREENS_ROUTES
          ),
        canMatch: [canMatchAuthGuard],
        data: {
          permission: new Permission('Devices', 'Index'),
          roles: [Roles.Tenant, Roles.TenantLocation],
          breadcrumb: { skip: true }
        }
      },
      {
        path: 'Dashboard',
        redirectTo: 'screens'
      },
      {
        path: 'devices',
        redirectTo: 'screens/screen-list'
      },
      {
        path: 'channels',
        redirectTo: 'screens/playlist'
      },
      {
        path: 'locations',
        redirectTo: 'screens/location-list'
      },
      {
        path: 'DeviceGroups',
        redirectTo: 'screens/groups'
      },
      {
        path: 'DeviceSchedules',
        redirectTo: 'screens/screen-scheduling'
      },
      {
        path: 'templates',
        redirectTo: 'screens/template-list'
      },
      {
        path: 'multimedia',
        redirectTo: 'screens/multimedia'
      },
      {
        path: 'DataClients',
        redirectTo: 'screens/data-client-list'
      },
      {
        path: 'admin-settings',
        redirectTo: 'security/security-policies'
      },
      {
        path: 'kiosks',
        loadChildren: () =>
          import('./products/kiosks/components/kiosks-routes').then(
            (m) => m.KIOSKS_ROUTES
          ),
        canMatch: [canMatchAuthGuard],
        data: {
          permission: new Permission('Kiosks', 'Index'),
          roles: [Roles.Tenant, Roles.TenantLocation],
          breadcrumb: { skip: true }
        }
      },
      {
        path: 'account',
        loadChildren: () =>
          import(
            './components/account-management/account-management-routes'
          ).then((m) => m.ACCOUNT_MANAGEMENT_ROUTES),
        data: {
          breadcrumb: 'account.Account'
        }
      },
      {
        path: 'security',
        loadChildren: () =>
          import('./components/security/security-routes').then(
            (m) => m.SECURITY_ROUTES
          ),
        data: {
          permission: new Permission('Profiles', 'Index'),
          roles: [Roles.Tenant],
          breadcrumb: { skip: true }
        }
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
      }
    ]
  }
];
